import { render, staticRenderFns } from "./LessonStatistics.vue?vue&type=template&id=251ea534&scoped=true&"
import script from "./LessonStatistics.vue?vue&type=script&lang=js&"
export * from "./LessonStatistics.vue?vue&type=script&lang=js&"
import style0 from "./LessonStatistics.vue?vue&type=style&index=0&id=251ea534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ea534",
  null
  
)

export default component.exports